import t from 'react-translate';
import { css } from '@emotion/react';
import ClickableContainer from 'components/clickable-container';
import NvIcon from 'shared/components/nv-icon';
import { gray2, gray6 } from 'styles/global_defaults/colors';
import NvTooltip from 'shared/components/nv-tooltip';
import { config } from '@config/pendo.config.json';
import { tooltipZIndex } from 'athena/components/constants';

type DeleteGoalOptionProps = {
  isReadOnly: boolean;
  goalItemId: number;
  onDelete: () => void;
};

const styles = css`
  &.delete-goal-item {
    color: ${gray2};
    opacity: 0;
    flex-shrink: 0;
    padding: 8px;

    &:hover {
      background: ${gray6};
      border-radius: 50%;
    }
  }
`;

const DeleteGoalOption = ({
  isReadOnly,
  goalItemId,
  onDelete,
}: DeleteGoalOptionProps) => {
  const dataQATag = config.pendo.athena.mentorshipProgram.participantHome.goals.list.item.deleteGoal;
  const deleteLabel = t.MENTORING_PROGRAMS.PARTICIPANT_HOME.GOALS.ITEM.TOOLTIP.DELETE_GOAL();

  return (
    <NvTooltip
      enabled={!isReadOnly}
      placement='top'
      text={deleteLabel}
      zIndex={tooltipZIndex}
    >
      <ClickableContainer
        css={styles}
        disabled={isReadOnly}
        onClick={onDelete}
        className='delete-goal-item'
        aria-label={deleteLabel}
        data-qa={dataQATag}
        data-qa-id={`${dataQATag}-${goalItemId}`}
      >
        <NvIcon icon='trash' size='xss-smallest' />
      </ClickableContainer>
    </NvTooltip>
  );
};

export default DeleteGoalOption;
